var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTTable',{attrs:{"title":"Fuente Modificación","subtitle":"Lista de Fuente Modificación","fields":_vm.fields,"items":_vm.$store.state.fuenteMod.fuentesMod},on:{"delete":function($event){return _vm.deleteItem($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }